/* LEDFROST v2.1 — FOMO badge on Kit Ski. */
(function () {
  'use strict';
  /* ---- FOMO badge on Kit Ski ---- */
  var T2 = {};
  try { T2 = JSON.parse((document.getElementById('lf-t2') || {}).textContent || '{}'); } catch (e) {}
  var ski = document.querySelector('.lf-model[data-model="ski"]');
  if (ski && T2.kit_pop && !ski.querySelector('.lf-model__b')) {
    var bd = document.createElement('span');
    bd.className = 'lf-model__b'; bd.textContent = T2.kit_pop;
    ski.appendChild(bd);
  }
})();
